<template>
    <div class="container">
        <v-title :lineage="[{'Automations':'automations'}]">
            Notifications
        </v-title>
        <v-form-tile>
             <h2 slot="title">Customer Notifications</h2>
            <div slot="description">
                <p class="text-muted stack-m">Configure notifications to be sent out automatically when certain events occur. You can specify exact conditions and even send out multiple emails per rule.</p>
                <p class="text-muted"
                    v-if="$auth.$pages['rules-engine'].isAllowed">For even more powerful automation, check out the <router-link :to="{name:'rules-engine'}">Rules Engine</router-link></p>
            </div>
            <div slot="content" class="tile">
                <div class="tile-content">
                    <div class="grid-content">
                        <div class="grid-item grid-item-full">
                        <v-radio
                            group="listViewOptions"
                            label="Show all events"
                            :value="false"
                            :model="showEmailEventsOnly"
                            @update="showEmailEventsOnly = false"/>
                        </div>
                        <div class="grid-item grid-item-full">
                        <v-radio
                            group="listViewOptions"
                            label="Show only events with Emails"
                            :value="true"
                            :model="showEmailEventsOnly"
                            :disabled="!eventsWithEmails.length"
                            @update="showEmailEventsOnly = true"/>
                        </div>
                    </div>
                </div>
                <div class="tile-content">
                    <event-list
                        :events="filteredEvents"
                        event-route="view-notifications">
                        <template #badges="{item}">
                            <div class="chip chip-s chip-secondary" v-show="item.emailBindsCount > 0">
                                <span class="inline-s">Emails</span><r-badge>{{item.emailBindsCount}}</r-badge>
                            </div>
                        </template>
                    </event-list>
                </div>
            </div>
        </v-form-tile>
    </div>
</template>

<script>
    import compare from '@/common/helpers/compare';
    import EventModel from '@/common/models/rules/event-model';
    import vTitle from '@/components/v-title';
    import {vRadio, vFormTile} from '@/components/form';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import EventList from '@/modules/rules-engine/components/index/event-list';

    export default {
        name: 'system-events',
        mixins: [LoadStateMixin],
        components: {
            vTitle, vRadio, vFormTile, EventList,
        },
        data() {
            return {
                showEmailEventsOnly: null,
                systemEvents: [],
                pageTitle: 'Notifications',
            };
        },
        computed: {
            filteredEvents() {
                if (this.showEmailEventsOnly && this.eventsWithEmails.length > 0) {
                    return this.eventsWithEmails;
                }
                return this.systemEvents;
            },
            eventsWithEmails() {
                if (this.systemEvents) {
                    return this.systemEvents.filter(event => event.emailBindsCount > 0);
                }
                return [];
            },
        },
        methods: {
            async fetchData() {
                const params = {limit: 50, offset: 0};
                const [
                    {items: eventsFields},
                    {items: emailCountsFields},
                ] = await this.$api(({events, emailNotifications}) => Promise.all([
                    events.getAll(params),
                    emailNotifications.getAll(params),
                ]));

                const sortedEmailCounts = [...emailCountsFields]
                    // Alphabetical sort by event type
                    .sort((a, b) => compare.values(a.fields.eventType, b.fields.eventType))
                    .map(({fields}) => fields.count);

                const items = [...eventsFields]
                    // Alphabetical sort by event type
                    .sort((a, b) => compare.values(a.fields.eventType, b.fields.eventType))
                    // Merge emailbindscount into events list
                    .map(({fields}, index) => ({
                        ...fields,
                        emailBindsCount: sortedEmailCounts[index],
                    }));

                this.systemEvents = items
                    // Filter only defined events.
                    .filter(({eventType}) => EventModel.Specs[eventType] !== undefined)
                    .map(item => new EventModel(item));


                this.setInitialListState();
            },
            // Show only events with emails, if there are any
            setInitialListState() {
                this.showEmailEventsOnly = this.eventsWithEmails.length > 0;
            },
        },
    };
</script>
